import { AuctionNews, fetchNewsItemsBySearchTerm } from '@/redux/api/auctionNews';
import {
    LOAD_AUCTION_NEWS_FAIL,
    LOAD_AUCTION_NEWS_FAIL_ACTION,
    LOAD_AUCTION_NEWS_SUCCESS,
    LOAD_AUCTION_NEWS_SUCCESS_ACTION,
} from './actions';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { handleActions } from 'redux-actions';

export interface State {
    newsItems: AuctionNews[];
}

export const DEFAULT_STATE: State = {
    newsItems: [],
};

export const reducer = handleActions(
    {
        [LOAD_AUCTION_NEWS_FAIL]: (state: State) => {
            return {
                ...state,
                newsItems: [],
            };
        },
        [LOAD_AUCTION_NEWS_SUCCESS]: (state: State, action: LOAD_AUCTION_NEWS_SUCCESS_ACTION) => {
            return {
                ...state,
                newsItems: action.payload,
            };
        },
    },
    DEFAULT_STATE
);

/* SELECTORS */
const stateSelector = (state: GlobalState): State => state.auctionNews;

export const getNewsItems = createSelector(stateSelector, (state) => state.newsItems || []);

/* ACTION CREATORS */
export const fetchAuctionNews = (search) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const deployment = getDeployment(state);

    try {
        const response = await fetchNewsItemsBySearchTerm({ deployment, search });
        dispatch({
            payload: response.payload,
            type: LOAD_AUCTION_NEWS_SUCCESS,
        } as LOAD_AUCTION_NEWS_SUCCESS_ACTION);
    } catch (error) {
        dispatch({
            error: true,
            meta: { search },
            payload: error,
            type: LOAD_AUCTION_NEWS_FAIL,
        } as LOAD_AUCTION_NEWS_FAIL_ACTION);
    }
};
